'use es6';

/**
 * @param {Axis} axis (reporting-visualizations)
 * @param {AxisScaleType} type (RelationalReport)
 * @returns {Axis}
 */
export const applyTypeToAxis = (axis, type) => type ? axis.set('type', type) : axis;